import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { AiGenerationLoadingContent } from 'components/AIGenerationLoadingContent'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

// `overlay` (default) sits inside AIVideoOverlayContent's already-16px-padded
// Content, so it uses the calc(100% + 14px) scrollbar-gutter hack. `sidebar`
// renders inside AIVideoContent's near-flush wrapper, so it mirrors the sibling
// GenerateTabContainer's exact horizontal box model (width: calc(100% + 28px),
// padding-inline: 14px, margin-right: 28px, overflow: hidden overlay) so the
// two tabs align pixel-for-pixel.
export const HistoryContainer = styled.div<{
  $variant?: 'sidebar' | 'overlay'
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: 28px;
  padding-top: 16px;
  gap: 16px;
  ${({ $variant }) =>
    $variant === 'sidebar'
      ? css`
          width: calc(100% + 28px);
          padding-inline: 14px;
          overflow: hidden overlay;
        `
      : css`
          width: calc(100% + 14px);
          padding-right: 14px;
          overflow-y: auto;
          box-sizing: content-box;
        `}
  ${customizeVerticalScrollbarThumbMixin()};
`

export const VideoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.borderColor};

  &:last-child {
    border-bottom: none;
  }
`

export const VideoSkeleton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${COLORS.secondaryUltraLight} 25%,
    ${COLORS.secondaryLight} 50%,
    ${COLORS.secondaryUltraLight} 75%
  );
  background-size: 400% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`

export const PlayButton = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    fill: ${COLORS.primaryDark};
    margin-left: 2px;
  }
`

export const LoadingWrapper = styled(AiGenerationLoadingContent)`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    & > :first-child {
      width: 100% !important;
    }
  }
`
